(function () {
	'use strict';

	angular
		.module('directives')
		.directive('relativeDatetime', onKeyCode);

	function onKeyCode() {
		var directive = {
			restrict: 'E',
			scope: {
				time: '='
			},
			template: template
		};

		return directive;

		function template() {
			return '<span class="relative-datetime" title="{{time | date:\'mediumDate\'}} {{time | date:\'shortTime\'}}">{{time | relativeTime}}</span>';
		}
	}
})();
